import {Attributes} from 'platform/components';

import {PersonResponseBodyV2} from '@dms/api/customer';
import {useCustomerPersonAttributes} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface PersonInfoProps {
  person?: PersonResponseBodyV2 | null;
  showRole?: boolean;
  showEmails?: boolean;
  showPhoneNumbers?: boolean;
  showPersonalIdentifier?: boolean;
  selfEmployed?: boolean | null;
}

/**
 * @deprecated [T20-125642] Uses @dms/teas. Replace usage with ContactPersonSelect from @dms/shared
 * which includes person info display with no teas dependency.
 * @see https://carvago.atlassian.net/browse/T20-125642
 */
export const PersonInfo = ({
  person,
  showRole,
  showEmails,
  showPhoneNumbers,
  selfEmployed: _selfEmployed,
  showPersonalIdentifier = true,
  ...rest
}: PersonInfoProps & TestIdProps) => {
  const [getAttributes] = useCustomerPersonAttributes();

  if (!person) {
    return null;
  }

  return (
    <Attributes
      data-testid={suffixTestId('personInfo', rest)}
      rows={getAttributes(person, {
        isRoleHidden: !showRole,
        isEmailsHidden: !showEmails,
        isPhoneNumbersHidden: !showPhoneNumbers,
        isPersonalIdentifierHidden: !showPersonalIdentifier,
      })}
      size="quarter"
    />
  );
};
